module.exports = __webpack_public_path__ + "img/index_1.85418fc5.jpg";